import { forwardRef, useCallback } from 'react'
import useDataKey from '../../hooks/useDataKey';
import { ChartsProps } from '../../interfaces/Indicator';
import { BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis, Tooltip, Legend, Bar, ReferenceLine } from 'recharts';
import CustomToolTip from './CustomToolTip';
import { INDICATOR_TYPE_PROCESS, messages } from '../../utils/const';
import NotDataDisplay from '../Cards/NotDataDisplay';
import { useChartDomains } from '../../hooks/useChartDomains';
import { useChartOrientation } from '../../hooks/useChartOrientation';
import { filterDataKeyByAnalysisVariables } from '../../views/IndicatorDisplay/utils/helpers';

const BarChartt = forwardRef<HTMLDivElement, ChartsProps>(({ data, typeOfIndicador, variable_analisis, range, errorsNoData, filters, tooltip_indicadores_proc, orientation }, ref) => {
    const { domainYLeft } = useChartDomains(
        data,
        variable_analisis,
        null,
        range!,
        null
    );

    const { layout, xAxisProps, yAxisProps, referenceLineProps } = useChartOrientation({
        orientation,
        valueAxis: { domain: domainYLeft, ticks: range?.ticks ?? undefined },
    });

    const { dataKey } = useDataKey(data, filters);

    const filteredDataKey = filterDataKeyByAnalysisVariables(
        dataKey ?? [],
        typeOfIndicador,
        variable_analisis
    );

    const tooltipContent = useCallback((props: any) => (
        <CustomToolTip
            {...props}
            isIndicatorTypeProc={typeOfIndicador === INDICATOR_TYPE_PROCESS}
            selectedKeys={tooltip_indicadores_proc ?? []}
        />
    ), [typeOfIndicador, tooltip_indicadores_proc]);

    const shouldShowTooltip = typeOfIndicador !== INDICATOR_TYPE_PROCESS || (tooltip_indicadores_proc ?? []).length > 0;

    return (
        <>
            <ResponsiveContainer width={'100%'} height={'100%'} ref={ref}>
                <BarChart
                    data={data}
                    layout={layout}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis {...xAxisProps} />
                    <YAxis {...yAxisProps} />
                    <Tooltip
                        content={shouldShowTooltip ? tooltipContent : undefined}
                        active={shouldShowTooltip ? undefined : false}
                        wrapperStyle={{ pointerEvents: 'auto', zIndex: 50 }}
                        isAnimationActive={false}
                    />
                    <Legend
                        wrapperStyle={{ fontSize: '0.875rem' }}
                        align='center'
                    />
                    <ReferenceLine
                        {...referenceLineProps}
                        stroke="#555C62"
                        strokeWidth="2"
                    />
                    {
                        filteredDataKey?.map((key, index) => (
                            <Bar
                                name={key.key.split('-').map(entity => entity.split(':')[1]).join('/') ?? "-"}
                                dataKey={key.key}
                                fill={key.color}
                                key={key.key}
                                isAnimationActive={false}
                            />
                        ))
                    }
                </BarChart>
            </ResponsiveContainer>
            {errorsNoData ? <NotDataDisplay message={messages.chart} /> : null}
        </>
    )
});

export default BarChartt